import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import './styles/menu.css';
import { FaHome, FaUsers, FaTasks, FaSignOutAlt, FaUserCircle, FaCalendar } from 'react-icons/fa';

function Menu({ isOpen, onClose, className }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isDashboard = location.pathname === '/';

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Logout fejl:', error);
    }
  };

  const menuItems = [
    {
      title: 'Dashboard',
      icon: <FaHome />,
      path: '/'
    },
    {
      title: 'Opgaver',
      icon: <FaTasks />,
      path: '/tasks/projects'
    },
    {
      title: 'CRM',
      icon: <FaUsers />,
      path: '/crm'
    },
    {
      title: 'Kalender',
      icon: <FaCalendar />,
      path: '/kalender'
    }
  ];

  return (
    <>
      {!isDashboard && (
        <div className={`menu-overlay ${isOpen ? 'active' : ''}`} onClick={onClose}></div>
      )}
      <nav className={`side-menu ${isOpen ? 'active' : ''} ${className}`}>
        {!isDashboard && (
          <button className="close-menu" onClick={onClose}>&times;</button>
        )}
        
        <div className="menu-header">
          <h1 className="brand-name">Parla Hub</h1>
        </div>

        <div className="menu-content">
          <div className="menu-section">
            <div className="section-title">Menu</div>
            <ul className="menu-items">
              {menuItems.map((item, index) => (
                <li key={index}>
                  <Link 
                    to={item.path} 
                    onClick={onClose}
                    className={location.pathname === item.path ? 'active' : ''}
                  >
                    <span className="menu-icon">{item.icon}</span>
                    <span className="menu-text">{item.title}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="menu-section">
            <div className="section-title">Konto</div>
            <ul className="menu-items">
              <li>
                <Link 
                  to="/profil" 
                  onClick={onClose}
                  className={location.pathname === '/profil' ? 'active' : ''}
                >
                  <span className="menu-icon"><FaUserCircle /></span>
                  <span className="menu-text">Profil</span>
                </Link>
              </li>
              <li>
                <button onClick={handleLogout} className="logout-button">
                  <span className="menu-icon"><FaSignOutAlt /></span>
                  <span className="menu-text">Log ud</span>
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="menu-footer">
          <div className="user-info">
            <div className="user-avatar">
              {auth.currentUser?.email?.charAt(0).toUpperCase()}
            </div>
            <div className="user-details">
              <div className="user-name">{auth.currentUser?.displayName || 'Bruger'}</div>
              <div className="user-email">{auth.currentUser?.email}</div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Menu;
